<template lang="html">
  <div class="">
    <Select v-model="filters.trashed">
      <Option :value="0"><Icon type="ios-person"/> Attivi</Option>
      <Option :value="1"><Icon type="ios-trash"/> Cestino</Option>
    </Select>
    &nbsp;
    <Input v-model="filters.search" placeholder="Ricerca..."/>

    <Button
    @click="$root.$emit('contact.show')"
    type="primary"
    style="float: right">
      <Icon type="plus-round"/>
      Nuovo contatto
    </Button>



    <div class="ivu-table spaced" style="margin: 1em 0">
      <table>
        <thead>
          <tr>
            <th style="width: 200px">Nome o Ragione Sociale</th>
            <th>Partita IVA</th>
            <th>Codice Fiscale</th>
            <th>Telefono</th>
            <th>Email</th>
            <th style="width: 200px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!contacts.length">
            <td colspan=6>
              Nessun contatto trovato
            </td>
          </tr>
          <tr v-for="t in contacts" :key="t.id">
            <td>{{ t.name }}</td>
            <td>{{ t.piva }}</td>
            <td>{{ t.cf }}</td>
            <td><code>{{ t.telephone }}</code></td>
            <td>
              <code>{{ t.email }}</code>
            </td>
            <td style="text-align: right">
              <ButtonGroup>
                <Button type="primary" shape="circle" @click="$root.$emit('contact.show', t)">
                  <Icon type="edit"/>
                </Button>
                <Button v-if="!t.deleted_at" type="error" shape="circle" @click=" confirm('Sicuri?') && $http['delete']('contacts/'+t.id).then(refreshContacts) ">
                  <Icon type="ios-trash"/>
                </Button>
                <Button v-else type="success" shape="circle" @click="$http['delete']('contacts/'+t.id).then(refreshContacts)">
                  Riattiva
                </Button>
              </ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
      <Spin size="large" fix v-if="loading"/>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      contacts: [],
      filters: {
        company_id: this.$store.company.id,
        trashed: 0,
      },
    }
  },

  mounted() {
    this.refreshContacts()
    this.$root.$on('contacts', this.refreshContacts)
  },
  beforeDestroy() {
    this.$root.$off('contacts', this.refreshContacts)
  },

  methods: {
    confirm(msg) {
      return confirm(msg)
    },
    refreshContacts(page) {
      var params = Object.assign({
      }, this.filters)
      this.loading = true
      this.$http.get('contacts', {params}).then(res => {
        this.contacts = res.data
      }).finally(res => {
        this.loading = false
      })
    },
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshContacts()
      }, 300)
    }
  }
}
</script>

<style lang="css">
</style>
